import { gql } from "@apollo/client";

const VALID_SUSPENSION = gql`
    query validSuspension($fechaDesde: CustomDateTime!, $fechaHasta: CustomDateTime!, $idEvaluacion: Int!){
        validSuspension(
            fechaDesde: $fechaDesde
            fechaHasta: $fechaHasta
            idEvaluacion: $idEvaluacion
        )
    }
`;

export default VALID_SUSPENSION;